import { createFileRoute, redirect } from '@tanstack/react-router';

// Inicio eliminado (decisión de Andrés): la home pasa a ser el Perfil. El login y cualquier
// navegación a '/' redirige a /me/profile.
export const Route = createFileRoute('/_authenticated/_layout/')({
    beforeLoad: () => {
        throw redirect({ to: '/me/profile' });
    },
});
